import LogoMain from '../App/LogoMain'

export function ContentLoader() {
  return (
    <div className="h-[100vh] w-[100%] flex">
      <LogoMain />
    </div>
  )
}
